<template>
  <div id="app">
    <!-- <keep-alive>
      
    </keep-alive> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue